import { Box, Flex, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { safariOnlyCss } from '../styles/theme';
import { MhyChakraProps } from '../types';

export const TeaserMetaField: FC<MhyChakraProps & { title: string }> = ({
  title,
  children,
  ...rest
}) => (
  <Box {...rest}>
    <Text textStyle="sm" color="secondaryColor" mb="2">
      {title}
    </Text>
    <Text>{children}</Text>
  </Box>
);

const TeaserMeta: FC<MhyChakraProps> = (props) => (
  <Flex
    {...props}
    gridColumnGap="5"
    gridRowGap="4"
    flexWrap="wrap"
    sx={safariOnlyCss({ '> *:not(:last-child)': { mr: 3, mb: 2 } })}
  />
);

export default TeaserMeta;
